import { IconButton } from "@mui/material";
import React, { useState } from "react";
import { TextInput } from "../text-input";
import IconInvisible from "./icon-invisible";
import IconVisible from "./icon-visible";
import "../text-input/styles.scss";
import { TextInputProps } from "../text-input/types";
import "./styles.scss";

export default function PasswordInput(
  props: TextInputProps,
): React.JSX.Element {
  const [showPassword, setShowPassword] = useState(false);
  const type = showPassword ? "text" : "password";
  return (
    <TextInput
      {...props}
      type={type}
      endAdornment={
        <IconButton
          className="scd-password-icon"
          tabIndex={0}
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <IconVisible /> : <IconInvisible />}
        </IconButton>
      }
    />
  );
}
